<template>
  <div>
    <!-- 移动端显示 -->
    <section
      v-if="pdp.product.categories.length > 1"
      :class="{ 'ua-pdt-bread': true, 'is-light': lightMode }"
    >
      <div class="ua-pdt-bread__ctt">
        <breadcrumb separator-class="el-icon-arrow-right">
          <breadcrumb-item :to="{ path: '/' }">首页</breadcrumb-item>
          <breadcrumb-item
            v-for="{ categoryName: label, categoryCode: code, extCode } in pdp.product.categories"
            :key="code"
            :to="{ path: `/list/c${extCode}` }"
          >
            {{ label }}
          </breadcrumb-item>
          <breadcrumb-item>
            {{ pdp.product.productName }}
          </breadcrumb-item>
        </breadcrumb>
      </div>
    </section>
    <!-- 不显示样式 -->
    <section v-else style="height: 48px; background-color: #fff"></section>
  </div>
</template>

<script>
import { Breadcrumb, BreadcrumbItem } from 'element-ui';
import { PDP } from '../lib/mixins';

export default {
  name: 'PdtBreadcrumb',
  components: { Breadcrumb, BreadcrumbItem },
  mixins: [PDP],
  props: { lightMode: { default: false, type: Boolean } }
};
</script>

<style lang="scss" layout="pc" description="网页端样式">
.ua-pdt-bread {
  background: #fff;
  position: sticky;
  top: 99px;
  left: 0px;
  right: 0px;
  z-index: 10;

  &.is-light {
    background: transparent;

    .el-breadcrumb__item {
      span {
        color: #fff;
      }

      &::last-of-type {
        span {
          color: #fff;
        }
      }
    }

    .el-breadcrumb__separator {
      color: #fff;
    }
  }

  &__ctt {
    max-width: 1440px;
    width: 85%;
    margin: 0 auto;
    position: relative;
    padding: 23px 0px;
  }

  .el-breadcrumb__item {
    span {
      font-size: 12px;
      line-height: 18px;
      color: var(--main-color-ua-dark-grey, #14141e);
      font-weight: 400;
    }

    &::last-of-type {
      span {
        color: var(--secondary-color-ua-cool-grey-02, #b4b4bf);
      }
    }
  }

  .el-breadcrumb__separator {
    color: var(--secondary-color-ua-cool-grey-02, #b4b4bf);
    font-size: 12px;
  }
}
</style>
